import { render, staticRenderFns } from "./OptionContainer.vue?vue&type=template&id=5edb5be1&scoped=true"
import script from "./OptionContainer.vue?vue&type=script&lang=js"
export * from "./OptionContainer.vue?vue&type=script&lang=js"
import style0 from "./OptionContainer.vue?vue&type=style&index=0&id=5edb5be1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edb5be1",
  null
  
)

export default component.exports